<template>
	<div v-if="ready" class="sal-components sal-components-wrapper sal-wrapper">
		<component
			:is="component"
			:security-id="securityId"
			:security-type="securityType"
			:content-type="contentType"
			:default-read-full="defaultReadFull"
			:show-analyst-rating="showAnalystRating"
			:show-holdings="showHoldings"
			:compare-tickers="compareTickers"
			:is-tender-offer-fund="isTenderOfferFund"
			:is-interval-fund="isIntervalFund"
			:is-unlisted-bdc-fund="isUnlistedBdcFund"
			:maas-token="maasToken"
			@load="$emit('load')"
			@beforeLoad="$emit('beforeLoad')"
			@error="$emit('error')"
		/>
	</div>
</template>

<script>
import loadScript from '@/lib/load-script';

export default {
	data() {
		return {
			ready: false
		};
	},
	props: {
		tab: {
			type: String,
			required: true
		},
		version: {
			type: String,
			default: process.env.VUE_APP_VERSION
		},
		securityId: {
			type: String,
			default: undefined
		},
		securityType: {
			type: String,
			default: undefined
		},
		contentType: {
			type: String,
			default: undefined
		},
		defaultReadFull: {
			type: Boolean,
			default: false
		},
		showAnalystRating: {
			type: Boolean,
			default: false
		},
		showHoldings: {
			type: Boolean,
			default: false
		},
		compareTickers: {
			type: String,
			default: ''
		},
		isTenderOfferFund: {
			type: Boolean,
			default: false
		},
		isIntervalFund: {
			type: Boolean,
			default: false
		},
		isUnlistedBdcFund: {
			type: Boolean,
			default: false
		},
		maasToken: {
			type: String,
			default: ''
		}
	},
	computed: {
		component() {
			return `sal-components-${this.tab}`;
		}
	},
	methods: {
		handleSalChicletClick(event) {
			this.$emit('chiclet-click', event.detail);
		},
		handleSalSegmentBandClick(event) {
			this.$emit('segment-band-click', event.detail);
		},
		handleSalSecurityClick(event) {
			switch (event.detail.type) {
			case 'marketsChart':
				this.$emit('chart-click', {
					securityId: event.detail.shareclassId,
					securityType: event.detail.securityType,
					mainTicker: event.detail.mainTicker,
					compareTickers: event.detail.compareTickers,
					userType: event.detail.userType
				});
				break;
			default:
				this.$emit('security-click', {
					securityId: event.detail.shareclassId,
					securityType: event.detail.securityType
				});
			}
		}
	},
	async mounted() {
		// @todo This should be packaged, not called from a third party
		loadScript('https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js');
		loadScript(`/assets/quotes/${this.version}/sal-components.umd.min.js`);

		document.addEventListener('sal.event.security.click', this.handleSalSecurityClick);
		document.addEventListener('sal.event.segmentBand.click', this.handleSalSegmentBandClick);
		document.addEventListener('sal.component.chiclet.click', this.handleSalChicletClick);

		this.ready = true;
	},
	async beforeDestroy() {
		document.removeEventListener('sal.event.security.click', this.handleSalSecurityClick);
		document.removeEventListener('sal.event.segmentBand.click', this.handleSalSegmentBandClick);
		document.removeEventListener('sal.component.chiclet.click', this.handleSalChicletClick);
	}
};
</script>
